import { useEffect } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { useSession } from './auth/SessionProvider';
import { useI18n } from './i18n';
import { Layout } from './components/Layout';
import { Spinner } from './components/ui';
import { LoginPage } from './pages/LoginPage';
import { ServersPage } from './pages/ServersPage';
import { ServerPage } from './pages/ServerPage';
import { LicensesPage } from './pages/LicensesPage';
import { AdminPage } from './pages/AdminPage';

export function App() {
  const { me, loading, isStaff } = useSession();
  const { t, adoptDefault } = useI18n();

  // La langue du profil Discord sert de valeur par défaut, jamais d'imposition.
  useEffect(() => {
    if (me) adoptDefault(me.locale);
  }, [me, adoptDefault]);

  if (loading) {
    return (
      <div className="shell">
        <main className="content">
          <Spinner label={t('common.loading')} />
        </main>
      </div>
    );
  }

  // Sans session, toute route mène à l'écran de connexion — y compris un lien profond,
  // qui redirigera correctement après authentification.
  if (!me) {
    return (
      <Routes>
        <Route path="*" element={<LoginPage />} />
      </Routes>
    );
  }

  return (
    <Routes>
      <Route element={<Layout />}>
        <Route index element={<Navigate to="/serveur" replace />} />
        <Route path="serveur" element={<ServersPage />} />
        <Route path="serveur/:id" element={<ServerPage />} />
        <Route path="licences" element={<LicensesPage />} />
        <Route
          path="admin"
          // Le garde côté serveur reste la seule protection réelle : celui-ci ne fait
          // qu'éviter d'afficher un écran qui ne renverrait que des 404.
          element={isStaff ? <AdminPage /> : <Navigate to="/serveur" replace />}
        />
        <Route path="*" element={<Navigate to="/serveur" replace />} />
      </Route>
    </Routes>
  );
}
